//
//  hooks/pwa/usePWAInstall.ts
//  TownLIT
//
//  Created by Hossein Sakkaki on 2026-08-19.
//  Last Update by Hossein Sakkaki on 2026-08-19.
//

"use client";

import { useContext } from "react";

import { PWAInstallContext } from "../../components/pwa/PWAInstallProvider";

export function usePWAInstall() {
  const context = useContext(PWAInstallContext);

  if (!context) {
    throw new Error(
      "usePWAInstall must be used inside PWAInstallProvider.",
    );
  }

  return context;
}